import {CSSProperties, memo, useMemo} from "react";
import {CELL_SIZE} from "../../utility/types";
import {Vec2} from "../../utility/math/vec2";

export const HoveredCell = memo(({position}: {position: Vec2}) => {
  const worldPos = position.mulScalar(CELL_SIZE).addScalar(0.5 * CELL_SIZE);

  const style = useMemo<CSSProperties>(
    () => ({
      width: `${CELL_SIZE - 4}px`,
      height: `${CELL_SIZE - 4}px`,
      backgroundColor: "var(--chakra3-colors-blue-100)",
      borderRadius: "var(--chakra3-radii-md)",
      position: "absolute",
      top: 0,
      left: 0,
      transform: `translate(${worldPos.x}px, ${worldPos.y}px) translate(-50%, -50%)`,
    }),
    [worldPos.x, worldPos.y],
  );

  return <div style={style} />;
});
